export default {
    isMobile: false,
    notifications: {
        active: false,
        unreadCounter: 0,
        new: []
    },
    isLoading: false,
    widget: {
        appointment: null,
        specialist: null
    },
    anytimeWidget: {
        meeting: null,
        user: null,
        otherUser: null
    },
    billingDetailsModal: {
        active: false
    }
}
